import { isWebview } from '@/utils/isWebview'

export function sendKarteEvent(
  eventName: string,
  values?: Record<string, unknown>
): void {
  if (typeof window === 'undefined' || typeof window.krt !== 'function') return

  window.krt('send', eventName, { ...values, from_webview: isWebview })
}
